<template>
	<div class="default">
		<h1><img src="~appAsset/ic_no_access.png" alt=""></h1>
		<p class="no-access">您的账号当前没有访问权限</p>
		<p class="contact">请联系后台管理员为您授权</p>
	</div>
</template>
<script type="text/javascript">
export default{
	name: "default",
	data(){
		return{
		}
	}
}
</script>

<style lang="scss">
	.default {
		width: 100%;
		height: 100%;
		background-color: #fff;
		padding-top: 50px;
		text-align: center;
		h1 {
			font-size: 350px;
			font-weight: bold;
			color: #cb6767;
		}
		.no-access {
			color: #333;
			font-size: 18px;
			margin-top: 20px;
		}
		.contact{
			font-size: 14px;
			color: #666;
			margin-top: 5px;
		}
	}
</style>


// WEBPACK FOOTER //
// default403.vue?64912d6e